import React, { Suspense } from 'react';
import { Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './CalendarUtils';
import CalendarPage from './CalendarPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';


const CalendarBasePage = () => {

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/calendar")) {
    const temp = menuList.find(q => q.url == "/calendar")
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute
            path="/calendar"
            render={props => <CalendarPage haveAccess={isFullAccess} reduxName="calendars" basePath="/calendar" api="api/calendar"
              columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} initObject={initObject} {...props} />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default CalendarBasePage



